import { cloneDeep } from 'lodash'

import { AskResponse, Citation } from '../../api'

export type ParsedAnswer = {
  citations: Citation[]
  markdownFormatText: string,
  generated_chart: string | null
} | null

export const enumerateCitations = (citations: Citation[]) => {
  const filepathMap = new Map()
  for (const citation of citations) {
    const { filepath } = citation
    let part_i = 1
    if (filepathMap.has(filepath)) {
      part_i = filepathMap.get(filepath) + 1
    }
    filepathMap.set(filepath, part_i)
    citation.part_index = part_i
  }
  return citations
}

export function parseAnswer(answer: AskResponse): ParsedAnswer {
  if (typeof answer.answer !== "string") return null
  let answerText = answer.answer
  const citationLinks = answerText.match(/\[(doc\d\d?\d?)]/g)

  const lengthDocN = '[doc'.length

  let filteredCitations = [] as Citation[]
  let citationReindex = 0

  // Helper function to normalize URLs and filepaths
  const normalizePath = (path: string | null) => {
    if (!path) return null;
    // Convert to lowercase and normalize slashes
    return path.toLowerCase().replace(/\\/g, '/').replace(/\/+$/, '');
  }

  citationLinks?.forEach(link => {
    const citationIndex = link.slice(lengthDocN, link.length - 1)
    const citation = cloneDeep(answer.citations[Number(citationIndex) - 1]) as Citation
    
    // Normalize URLs and filepaths for comparison
    const normalizedUrl = normalizePath(citation.url);
    const normalizedFilepath = normalizePath(citation.filepath);
    
    // Check for existing citation with same URL or filepath
    const existingCitation = filteredCitations.find(c => {
      const cNormalizedUrl = normalizePath(c.url);
      const cNormalizedFilepath = normalizePath(c.filepath);
      
      // If both have URLs, compare them
      if (normalizedUrl && cNormalizedUrl) {
        return normalizedUrl === cNormalizedUrl;
      }
      // If both have filepaths, compare them
      if (normalizedFilepath && cNormalizedFilepath) {
        return normalizedFilepath === cNormalizedFilepath;
      }
      return false;
    });
    
    if (!existingCitation && citation) {
      answerText = answerText.replaceAll(link, ` ^${++citationReindex}^ `)
      citation.id = citationIndex // original doc index
      citation.reindex_id = citationReindex.toString() // reindex from 1 for display
      filteredCitations.push(citation)
    } else if (existingCitation) {
      // Replace the citation link with the existing citation's reindex number
      const existingIndex = filteredCitations.indexOf(existingCitation) + 1
      answerText = answerText.replaceAll(link, ` ^${existingIndex}^ `)
    }
  })

  filteredCitations = enumerateCitations(filteredCitations)

  return {
    citations: filteredCitations,
    markdownFormatText: answerText,
    generated_chart: answer.generated_chart
  }
}
